import './App.css';
import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigationType } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './screen/Home/Home';
import Company from './screen/Company/Company';
import Faq from './screen/Faq/Faq';
import Portfolio from './screen/Portfolio/Portfolio';
import PortfolioDetail from './screen/Portfolio/PortfolioDetail';
import Quote from './screen/Quote/Quote';
import QuoteComplete from './screen/Quote/QuoteComplete';
import Wowpress from './screen/Wowpress/Wowpress';
import Checkout from './screen/Checkout/Checkout';
import OrderStart from './screen/Order/OrderStart';
import Estimate from './screen/Estimate/Estimate';
import Works from './screen/Works/Works';
import Lookup from './screen/Lookup/Lookup';
import Login from './screen/Auth/Login';
import Signup from './screen/Auth/Signup';
import SignupComplete from './screen/Auth/SignupComplete';
import OAuthCallback from './screen/Auth/OAuthCallback';
import ProofViewer from './screen/MyPage/ProofViewer';
import PaymentSuccess from './screen/Payment/PaymentSuccess';
import PaymentFail from './screen/Payment/PaymentFail';
import AdminDashboard from './screen/Admin/Dashboard/AdminDashboard';
import AdminOrders from './screen/Admin/AdminOrders';
import AdminOrderDetail from './screen/Admin/AdminOrderDetail';
import AdminEstimate from './screen/Admin/AdminEstimate';
import AdminSignup from './screen/Admin/AdminSignup';
import AdminLogin from './screen/Admin/AdminLogin';
import AdminAccounts from './screen/Admin/Accounts/AdminAccounts';
import AdminPortfolio from './screen/Admin/Portfolio/AdminPortfolio';
import AdminPortfolioForm from './screen/Admin/Portfolio/AdminPortfolioForm';
import AdminChatbot from './screen/Admin/Chatbot/AdminChatbot';
import AdminWorks from './screen/Admin/Works/AdminWorks';
import AdminCertifications from './screen/Admin/Certifications/AdminCertifications';
import AdminPartners from './screen/Admin/Partners/AdminPartners';
import AdminCompanyHistory from './screen/Admin/CompanyHistory/AdminCompanyHistory';
import MyPage from './screen/MyPage/MyPage';
import Chatbot from './components/chatbot/Chatbot';
import { SiteAdminOrderAlert } from './screen/Admin/AdminOrderAlert';

function App() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const isAdmin = location.pathname.startsWith('/admin');

  // 페이지 이동 시 스크롤 위치: 링크로 이동하면 맨 위(주소에 #가 있으면 그 영역)로,
  // 뒤로가기/앞으로가기(POP)는 브라우저가 이전 위치를 복원하도록 둔다
  useEffect(() => {
    if (navigationType === 'POP') return;
    if (location.hash) {
      const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (target) {
        target.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash, navigationType]);


  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/signup" element={<AdminSignup />} />
        {/* 견적문의(INQUIRY)와 주문관리(ORDER)는 같은 화면을 메뉴별로 나눠 쓴다 */}
        <Route path="/admin/inquiries" element={<AdminOrders key="inquiries" requestType="INQUIRY" />} />
        <Route path="/admin/orders" element={<AdminOrders key="orders" requestType="ORDER" />} />
        <Route path="/admin/orders/:id" element={<AdminOrderDetail />} />
        <Route path="/admin/orders/:id/estimate" element={<AdminEstimate />} />
        <Route path="/admin/accounts" element={<AdminAccounts />} />
        <Route path="/admin/portfolio" element={<AdminPortfolio />} />
        <Route path="/admin/portfolio/new" element={<AdminPortfolioForm />} />
        <Route path="/admin/portfolio/:id/edit" element={<AdminPortfolioForm />} />
        <Route path="/admin/works" element={<AdminWorks />} />
        <Route path="/admin/certifications" element={<AdminCertifications />} />
        <Route path="/admin/partners" element={<AdminPartners />} />
        <Route path="/admin/company-history" element={<AdminCompanyHistory />} />
        <Route path="/admin/chatbot" element={<AdminChatbot />} />
      </Routes>
    );
  }

  return (
    <div className="App">
      <Header />
      <div className="Main">
        <Routes>
          <Route path="/" element={<Home />} />
          {/* 회사소개: /company 는 첫 하위 메뉴(인사말)로 이동 / key로 페이지 전환 시 새로 마운트(등장 효과 재실행) */}
          <Route path="/company" element={<Navigate to="/company/greeting" replace />} />
          <Route path="/company/greeting" element={<Company key="greeting" section="greeting" />} />
          <Route path="/company/vision" element={<Company key="vision" section="vision" />} />
          <Route path="/company/history" element={<Company key="history" section="history" />} />
          <Route path="/company/certification" element={<Company key="certification" section="certification" />} />
          <Route path="/company/partners" element={<Company key="partners" section="partners" />} />
          <Route path="/company/location" element={<Company key="location" section="location" />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:id" element={<PortfolioDetail />} />
          {/* 주문하기: 디자인 없음(/portfolio) · 디자인 있음(/order/print) → 주문서 작성(/order/form) */}
          <Route path="/order" element={<OrderStart />} />
          <Route path="/order/print" element={<Wowpress />} />
          <Route path="/order/form" element={<Quote key="order" mode="order" />} />
          <Route path="/order/checkout/:id" element={<Checkout />} />
          <Route path="/quote" element={<Quote key="inquiry" mode="inquiry" />} />
          <Route path="/quote/complete" element={<QuoteComplete />} />
          <Route path="/estimate/:id" element={<Estimate />} />
          <Route path="/wowpress" element={<Navigate to="/order/print" replace />} />
          <Route path="/works" element={<Works />} />
          <Route path="/lookup" element={<Lookup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signup/complete" element={<SignupComplete />} />
          <Route path="/oauth/kakao/callback" element={<OAuthCallback provider="kakao" />} />
          <Route path="/oauth/naver/callback" element={<OAuthCallback provider="naver" />} />
          <Route path="/mypage" element={<MyPage />} />
          <Route path="/mypage/proof/:id" element={<ProofViewer />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/fail" element={<PaymentFail />} />
        </Routes>
      </div>
      <Footer />
      <Chatbot />
      {/* 관리자로 로그인된 상태면 사용자 화면에서도 신규 접수 알림을 띄운다 */}
      <SiteAdminOrderAlert />
    </div>
  );
}

export default App;
